const DEFAULT_LIVESTREAM_APP_LINK = 'https://startengine.onelink.me/rNUQ/livestream';

export const LIVESTREAM_APP_LINK_BASE =
  process.env.NEXT_PUBLIC_LIVESTREAM_APP_LINK || DEFAULT_LIVESTREAM_APP_LINK;

export type LiveStreamLinkType = 'live' | 'scheduled';

export const getLiveStreamAppLink = (
  streamId?: string,
  type?: LiveStreamLinkType,
  action?: string,
  offeringId?: string | number,
): string => {
  const url = new URL(LIVESTREAM_APP_LINK_BASE);
  if (streamId) url.searchParams.set('deep_link_sub1', streamId);
  if (type) url.searchParams.set('deep_link_sub2', type);
  if (action) url.searchParams.set('deep_link_sub3', action);
  if (offeringId) url.searchParams.set('deep_link_sub4', String(offeringId));
  return url.toString();
};
